import { createFileRoute } from '@tanstack/react-router'

import { BugPage } from '@/components/bugs/bug-page'
import { RETURN_SHAPE } from '@/lib/return-to'
import { readSearch } from '@/lib/search-params'

/** Lot 47 : la fiche d'un bug, par sa référence (« ACME:BUG-12 ») ou son id. */
export const Route = createFileRoute('/_app/qa/bugs/$bugRef')({
  // #401 : « Retour » ramène là d'où l'on vient, filtres compris.
  validateSearch: (search: Record<string, unknown>) => readSearch(RETURN_SHAPE, search),
  component: BugRoutePage,
})

function BugRoutePage() {
  const { bugRef } = Route.useParams()
  return <BugPage key={bugRef} bugRef={bugRef} />
}
